import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTourStore } from '@/stores/tourStore';

/**
 * EndScreen — the final completion modal of the guided product tour. Shown
 * after the deep_dive_preferences sub-tour's last step (Phase 3b).
 *
 * Open/close state is read from `tourStore` (`showEndScreen`). Tutorial
 * completion is already persisted by `endTour(true)` before this opens, so the
 * single "got it" button just closes the modal.
 */
export default function EndScreen() {
  const showEndScreen = useTourStore((s) => s.showEndScreen);
  const closeEndScreen = useTourStore((s) => s.closeEndScreen);

  return (
    <Dialog
      open={showEndScreen}
      onOpenChange={(open) => {
        // Soft dismiss (X / outside click) behaves the same as "got it".
        if (!open) closeEndScreen();
      }}
    >
      {/* z-index above driver.js's 1e9 popover so this dialog is never behind it. */}
      <DialogContent
        className="max-w-md mx-4 z-[1000000002] bg-white border border-hairline rounded-lg"
        overlayClassName="z-[1000000001]"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-ink text-xl">you're all set 🚀</DialogTitle>
          <DialogDescription className="text-base pt-1 text-steel-dark">
            go make some posts. you can replay this whole tour anytime from
            Settings → Preferences.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-4">
          <Button
            onClick={closeEndScreen}
            size="lg"
            className="w-full bg-cargo hover:bg-cargo/90 text-cargo-ink rounded-md focus-visible:ring-ink"
          >
            got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
